<template>
  <div>
    <div class="filiais-sac__header">
      <h5 class="filiais-sac__title">Filiais vinculadas (SAC)</h5>
      <p class="filiais-sac__subtitle">
        Restringe a visualização de tickets do SAC às filiais selecionadas.
        Aplicado apenas para colaboradores dos tipos Atendente e Funcionário.
      </p>
    </div>

    <div v-if="!colaboradorId" class="filiais-sac__empty">
      Salve o colaborador antes de vincular filiais.
    </div>

    <div v-else>
      <div v-if="loading" class="filiais-sac__loading">Carregando filiais...</div>

      <div v-else>
        <div v-if="!filiais.length" class="filiais-sac__empty">
          Nenhuma filial cadastrada.
        </div>
        <div v-else class="filiais-sac__list">
          <label
            v-for="filial in filiais"
            :key="filial.id"
            class="filiais-sac__item"
          >
            <input
              type="checkbox"
              :value="filial.id"
              v-model="selecionadas"
            />
            <span class="filiais-sac__item-text">
              <strong>{{ filial.id }}</strong>
              -
              {{ filial.fantasia || filial.razaosocial }}
            </span>
          </label>
        </div>

        <div class="filiais-sac__actions">
          <button
            type="button"
            class="button button-primary"
            :disabled="salvando"
            @click="salvar"
          >
            <span v-if="salvando">Salvando...</span>
            <span v-else>Salvar filiais</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { get, put } from "../../../helpers/apiRequest";

export default {
  name: "FiliaisSac",
  props: {
    colaboradorId: {
      type: [Number, String],
      default: null,
    },
  },
  data() {
    return {
      filiais: [],
      selecionadas: [],
      loading: false,
      salvando: false,
    };
  },
  watch: {
    colaboradorId: {
      immediate: true,
      handler(id) {
        if (id) {
          this.carregar();
        } else {
          this.filiais = [];
          this.selecionadas = [];
        }
      },
    },
  },
  methods: {
    async carregar() {
      this.loading = true;
      try {
        const [todas, vinculadas] = await Promise.all([
          get(`/admin/filiais`),
          get(`/admin/colaborador/${this.colaboradorId}/filiais`),
        ]);

        this.filiais = todas.itens || todas || [];
        const lista = vinculadas.itens || vinculadas || [];
        this.selecionadas = lista.map((f) =>
          typeof f === "object" ? f.id : f
        );
      } catch (e) {
        this.$swal({
          title: "Falha ao carregar filiais",
          text: e.message || "Não foi possível carregar as filiais.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "Fechar",
        });
      } finally {
        this.loading = false;
      }
    },
    async salvar() {
      this.salvando = true;
      try {
        await put(`/admin/colaborador/${this.colaboradorId}/filiais`, {
          filiais: this.selecionadas,
        });
        this.$swal({
          title: "Filiais salvas",
          text: "Vínculo atualizado com sucesso.",
          icon: "success",
          showConfirmButton: true,
          confirmButtonText: "Fechar",
        });
      } catch (e) {
        this.$swal({
          title: "Falha ao salvar",
          text: e.message || "Não foi possível salvar as filiais vinculadas.",
          icon: "error",
          showConfirmButton: true,
          confirmButtonText: "Fechar",
        });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>

<style scoped>
.filiais-sac__header {
  margin-bottom: 12px;
}

.filiais-sac__title {
  font-size: 14px;
  font-weight: 600;
  color: #3c4b64;
  margin: 0 0 4px 0;
}

.filiais-sac__subtitle {
  font-size: 12px;
  color: #667085;
  margin: 0;
}

.filiais-sac__loading,
.filiais-sac__empty {
  padding: 16px;
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 6px;
  font-size: 13px;
  color: #667085;
  text-align: center;
}

.filiais-sac__list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 8px;
  max-height: 420px;
  overflow-y: auto;
  padding: 12px;
  background: #f8f9fa;
  border: 1px solid #e4e7ea;
  border-radius: 6px;
}

.filiais-sac__item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid #e4e7ea;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
  margin: 0;
}

.filiais-sac__item:hover {
  border-color: #3c4b64;
}

.filiais-sac__item input[type="checkbox"] {
  margin: 0;
}

.filiais-sac__item-text {
  flex: 1;
}

.filiais-sac__actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}
</style>
